module.exports = __webpack_public_path__ + "static/media/paulina3.6bd0c6d1.png";